<script setup>
import { ref } from "vue";
const tab = ref(null)
const content11 = ref()
const content0 = ref()
const content1 = ref()
const content2 = ref()
const content3 = ref()
const content4 = ref()
const content5 = ref()
const content6 = ref()
const changeTab = (i)=>{
  if(tab.value === i ){
    tab.value = null
  } else {
   tab.value = i
  }
}
</script>
<template>
  <main class="mt-[60px] md:mt-[70px]">
    <div>
      <div class="mx-auto flex max-w-[960px] gap-10 px-4 pb-4 lg:px-0">
        <div class="w-full flex-1 md:max-w-[600px]">
          <div>
            <div
              class="no-scrollbar mt-4 flex overflow-x-auto pt-4 md:mt-6"
              aria-label="Breadcrumb"
            >
              <ol class="inline-flex items-center">
                <li>
                  <div class="flex items-center text-sm font-normal">
                    <a
                      href="/"
                      class="whitespace-nowrap text-gray-accent3 hover:text-breadcrumb-link-hover"
                      >Home</a
                    >
                    <div class="px-2">/</div>
                  </div>
                </li>
                <li>
                  <div class="flex items-center text-sm font-normal">
                    <a
                      href="/calculator/"
                      class="whitespace-nowrap text-gray-accent3 hover:text-breadcrumb-link-hover"
                      >Calculators</a
                    >
                    <div class="px-2">/</div>
                  </div>
                </li>
                <li
                  class="w-50 truncate pr-7 text-sm font-normal text-lighter-black sm:w-72"
                >
                  SIP Calculator
                </li>
              </ol>
            </div>
            <h1
              class="my-1 text-2xl font-semibold not-italic leading-8 tracking-[-0.24px] md:my-2"
            >
              SIP Calculator
            </h1>
            <p
              class="!mb-7 text-sm font-normal not-italic leading-6 text-grey-8 md:text-base"
            >
              Estimate future returns and set goals with our SIP calculator.
              Start growing your wealth with Systematic Investment Plan (SIP)
              today!
            </p>
            <div
              class="no-scrollbar border-b-blacks-3 flex h-[var(--tab-bar-height)] overflow-x-scroll border-b"
            >
              <a
                class="display-xxs ipad:mr-4 mr-2 flex flex-shrink-0 cursor-pointer border-b-2 border-b-primary-base pb-2 font-semibold text-main-6"
                href="/calculator/sip-calculator/"
                ><div class="ipad:px-1 px-3">SIP</div></a
              ><a
                class="display-xxs ipad:mr-4 mr-2 flex flex-shrink-0 cursor-pointer text-dark-2 transition-colors"
                href="/calculator/lumpsum-calculator/"
                ><div class="ipad:px-1 px-3">Lumpsum</div></a
              >
            </div>
            <div class="flex flex-col gap-6">
              <div class="pt-[16px]">
                <div class="upstox-radio-group" role="radiogroup">
                  <div class="radio-wrapper">
                    <input
                      type="radio"
                      id="I know my investment"
                      class="radio-input"
                      name="investment-goal-radio-group"
                      checked=""
                      value="investment"
                    /><label
                      role="radio"
                      aria-checked="true"
                      tabindex="0"
                      for="I know my investment"
                      class="radio-label"
                      >I know my investment</label
                    >
                  </div>
                  <div class="radio-wrapper">
                    <input
                      type="radio"
                      id="I know my goal"
                      class="radio-input"
                      name="investment-goal-radio-group"
                      value="goal"
                    /><label
                      role="radio"
                      aria-checked="false"
                      tabindex="0"
                      for="I know my goal"
                      class="radio-label"
                      >I know my goal</label
                    >
                  </div>
                </div>
              </div>
              <div>
                <div class="flex w-full items-center justify-between mb-2">
                  <div class="w-full max-w-[173px] md:max-w-[551px]">
                    <label
                      class="text-sm leading-5 text-black-6 font-semibold"
                      for="Monthly SIP amount"
                      >Monthly SIP amount</label
                    >
                  </div>
                  <div class="relative">
                    <span
                      class="absolute left-3 top-[10px] mr-6 text-xs font-medium leading-4 text-dark-2"
                      >₹</span
                    ><input
                      class="h-[36px] rounded border !border-grey-9 px-3 py-2 text-xs font-medium leading-4 disabled:cursor-not-allowed disabled:bg-grey-7 disabled:text-grey-2 !pl-[20px] !w-[112px] md:!w-[112px]"
                      type="text"
                      id="Monthly SIP amount"
                      name="Monthly SIP amount"
                      value="5000"
                    />
                  </div>
                </div>
                <span
                  dir="ltr"
                  data-orientation="horizontal"
                  aria-disabled="false"
                  class="relative flex h-[50px] w-full select-none items-center px-2"
                  aria-label="Volume"
                  style="--radix-slider-thumb-transform: translateX(-50%)"
                  ><div
                    class="relative h-[2px] flex-grow cursor-pointer rounded-[4px] bg-gray-accent"
                  >
                    <span
                      data-orientation="horizontal"
                      class="absolute h-full rounded-full bg-primary-base"
                      style="left: 0%; right: 99.5%"
                    ></span>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 0%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] invisible bg-primary-base"
                      ></div>
                      <span
                        class="relative text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal left-[-30%]"
                        >0</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 20%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >2L</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 40%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >4L</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 60%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >6L</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 80%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >8L</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 100%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent invisible"
                      ></div>
                      <span
                        class="relative text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal left-[-70%]"
                        >10L</span
                      >
                    </div>
                  </div>
                  <span
                    style="
                      transform: var(--radix-slider-thumb-transform);
                      position: absolute;
                      left: calc(0.5% + 11.88px);
                    "
                    ><span
                      role="slider"
                      aria-valuemin="0"
                      aria-valuemax="1000000"
                      aria-orientation="horizontal"
                      data-orientation="horizontal"
                      tabindex="0"
                      class="flex h-6 w-6 cursor-pointer rounded-full bg-primary-base focus:outline-none"
                      style=""
                      data-radix-collection-item=""
                      aria-valuenow="5000"
                    ></span></span
                ></span>
              </div>
              <div class="pb-2">
                <div class="mb-2 flex items-center justify-between">
                  <label class="text-sm leading-5 text-black-6 font-semibold"
                    >Expected return rate (per annum)</label
                  >
                  <div class="flex gap-2">
                    <input
                      class="h-[36px] !w-[56px] rounded border !border-grey-9 px-2 py-2 text-xs font-medium leading-4 disabled:cursor-not-allowed disabled:bg-grey-7 disabled:text-grey-2"
                      type="text"
                      id="expected-return-rate"
                      aria-label="Expected return rate (per annum)"
                      name="expected-return-rate"
                      value="12"
                    />
                  </div>
                </div>
                <span
                  dir="ltr"
                  data-orientation="horizontal"
                  aria-disabled="false"
                  class="relative flex h-[50px] w-full select-none items-center px-2"
                  aria-label="Volume"
                  style="--radix-slider-thumb-transform: translateX(-50%)"
                  ><div
                    class="relative h-[2px] flex-grow cursor-pointer rounded-[4px] bg-gray-accent"
                  >
                    <span
                      data-orientation="horizontal"
                      class="absolute h-full rounded-full bg-primary-base"
                      style="left: 0%; right: 76%"
                    ></span>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 0%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] invisible bg-primary-base"
                      ></div>
                      <span
                        class="relative text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal left-[-30%]"
                        >0%</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 20%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-primary-base"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >10%</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 40%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >20%</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 60%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >30%</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 80%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >40%</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 100%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent invisible"
                      ></div>
                      <span
                        class="relative text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal left-[-70%]"
                        >50%</span
                      >
                    </div>
                  </div>
                  <span
                    style="
                      transform: var(--radix-slider-thumb-transform);
                      position: absolute;
                      left: calc(24% + 6.24px);
                    "
                    ><span
                      role="slider"
                      aria-valuemin="0"
                      aria-valuemax="50"
                      aria-orientation="horizontal"
                      data-orientation="horizontal"
                      tabindex="0"
                      class="flex h-6 w-6 cursor-pointer rounded-full bg-primary-base focus:outline-none"
                      style=""
                      data-radix-collection-item=""
                      aria-valuenow="12"
                    ></span></span
                ></span>
              </div>
              <div class="pb-2">
                <div class="mb-2 flex items-center justify-between">
                  <label class="text-sm leading-5 text-black-6 font-semibold"
                    >Tenure</label
                  >
                  <div class="flex gap-2">
                    <input
                      class="h-[36px] !w-[56px] rounded border !border-grey-9 px-2 py-2 text-xs font-medium leading-4 disabled:cursor-not-allowed disabled:bg-grey-7 disabled:text-grey-2"
                      type="text"
                      id="sip-tenure"
                      aria-label="Tenure"
                      name="sip tenure"
                      value="5"
                    />
                    <div
                      class="flex items-center justify-between w-auto mb-0 h-[36px]"
                    >
                      <div
                        id="sip tenure"
                        class="relative md:max-w-[250px] bg-white w-auto md:min-w-[90px] border rounded border-grey-9"
                      >
                        <div
                          class="flex h-[36px] cursor-pointer items-center justify-between rounded border px-2 md:px-3"
                        >
                          <div
                            class="flex items-center text-xs font-medium leading-4"
                          >
                            <span class="mr-2 text-xs">Year(s)</span>
                          </div>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              id="keyboard_arrow_down_FILL0_wght400_GRAD0_opsz24 1"
                            >
                              <path
                                id="Vector"
                                d="M8 10.2666L4 6.26665L4.93333 5.33331L8 8.39998L11.0667 5.33331L12 6.26665L8 10.2666Z"
                                fill="black"
                              ></path>
                            </g>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <span
                  dir="ltr"
                  data-orientation="horizontal"
                  aria-disabled="false"
                  class="relative flex h-[50px] w-full select-none items-center px-2"
                  aria-label="Volume"
                  style="--radix-slider-thumb-transform: translateX(-50%)"
                  ><div
                    class="relative h-[2px] flex-grow cursor-pointer rounded-[4px] bg-gray-accent"
                  >
                    <span
                      data-orientation="horizontal"
                      class="absolute h-full rounded-full bg-primary-base"
                      style="left: 0%; right: 80%"
                    ></span>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 0%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] invisible bg-primary-base"
                      ></div>
                      <span
                        class="relative text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal left-[-30%]"
                        >0Y</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 20%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-primary-base"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >5Y</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 40%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >10Y</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 60%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >15Y</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 80%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent"
                      ></div>
                      <span
                        class="relative left-[-50%] text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal"
                        >20Y</span
                      >
                    </div>
                    <div
                      class="absolute top-[-3px] flex flex-col gap-2"
                      style="left: 100%"
                    >
                      <div
                        class="h-[10px] w-[2px] rounded-[4px] bg-gray-accent invisible"
                      ></div>
                      <span
                        class="relative text-[10px] font-medium not-italic leading-5 text-grey-8 sm:text-sm sm:font-normal left-[-70%]"
                        >25Y</span
                      >
                    </div>
                  </div>
                  <span
                    style="
                      transform: var(--radix-slider-thumb-transform);
                      position: absolute;
                      left: calc(20% + 7.2px);
                    "
                    ><span
                      role="slider"
                      aria-valuemin="0"
                      aria-valuemax="25"
                      aria-orientation="horizontal"
                      data-orientation="horizontal"
                      tabindex="0"
                      class="flex h-6 w-6 cursor-pointer rounded-full bg-primary-base focus:outline-none"
                      style=""
                      data-radix-collection-item=""
                      aria-valuenow="5"
                    ></span></span
                ></span>
              </div>
            </div>
            <hr class="my-6 h-px border-0 bg-grey-7" />
            <div
              class="flex-col items-center gap-1 rounded border border-grey-7 md:gap-0 md:rounded-b-none"
            >
              <div
                class="items-start border-b border-grey-7 bg-gray-50 px-4 py-3"
              >
                <p class="text-sm font-semibold text-gray-primary">
                  Investment vs returns
                </p>
              </div>
              <div
                class="justify-between px-4 pb-6 pt-5 md:flex md:items-center md:gap-0 md:px-12 md:pb-11 md:pt-7"
              >
                <!--$--><!--/$-->
                <div
                  class="w-45 flex h-40 items-center justify-center px-[10px] md:h-[230px] md:w-[230px] md:p-0"
                >
                  <div
                    class="recharts-responsive-container"
                    style="width: 100%; height: 100%; min-width: 0px"
                  >
                    <div
                      class="recharts-wrapper"
                      style="
                        position: relative;
                        cursor: default;
                        width: 100%;
                        height: 100%;
                        max-height: 230px;
                        max-width: 230px;
                      "
                    >
                      <svg
                        cx="50%"
                        cy="50%"
                        class="recharts-surface"
                        width="230"
                        height="230"
                        viewBox="0 0 230 230"
                        style="width: 100%; height: 100%"
                      >
                        <title></title>
                        <desc></desc>
                        <defs>
                          <clipPath id="recharts1-clip">
                            <rect x="5" y="5" height="220" width="220"></rect>
                          </clipPath>
                        </defs>
                        <g
                          class="recharts-layer recharts-pie h-45 w-40 outline-none md:h-[230px] md:w-[230px]"
                          tabindex="0"
                        >
                          <g class="recharts-layer">
                            <g
                              class="recharts-layer recharts-pie-sector"
                              tabindex="-1"
                            >
                              <path
                                cx="115"
                                cy="115"
                                name="Invested amount"
                                class="recharts-sector h-45 w-40 outline-none md:h-[230px] md:w-[230px]"
                                stroke="#fff"
                                fill="#AE8AD2"
                                cursor="pointer"
                                tabindex="-1"
                                d="M 195,115
    A 80,80,0,
    1,0,
    103.67462255088276,194.19429162278698
  L 107.6385046580738,166.47628955481153
            A 52,52,0,
            1,1,
            167,115 Z"
                                role="img"
                              ></path>
                            </g>
                            <g
                              class="recharts-layer recharts-pie-sector"
                              tabindex="-1"
                            >
                              <path
                                cx="115"
                                cy="115"
                                name="Total returns"
                                class="recharts-sector h-45 w-40 outline-none md:h-[230px] md:w-[230px]"
                                stroke="#fff"
                                fill="#30B48E"
                                cursor="pointer"
                                tabindex="-1"
                                d="M 103.67462255088276,194.19429162278698
    A 80,80,0,
    0,0,
    195,115.00000000000001
  L 167,115.00000000000001
            A 52,52,0,
            0,1,
            107.6385046580738,166.47628955481153 Z"
                                role="img"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </svg>
                      <div
                        tabindex="-1"
                        class="recharts-tooltip-wrapper"
                        style="
                          visibility: hidden;
                          pointer-events: none;
                          position: absolute;
                          top: 0px;
                          left: 0px;
                        "
                      ></div>
                    </div>
                  </div>
                </div>
                <div
                  class="mt-[26px] flex flex-col gap-6 md:mt-0 md:justify-center md:gap-5"
                >
                  <div
                    class="border-border-light flex flex-col items-center gap-1 rounded border px-4 py-2 md:min-w-28 md:items-start"
                  >
                    <p class="text-sm font-medium text-dark-2">
                      Total value of investment
                    </p>
                    <p
                      class="whitespace-nowrap text-xl font-semibold text-success-1"
                    >
                      ₹
                      <!-- -->4,12,431.83
                    </p>
                  </div>
                  <div
                    class="flex flex-wrap items-start justify-between md:flex-col md:flex-nowrap md:gap-3"
                  >
                    <div class="flex flex-col gap-2">
                      <div class="flex items-center gap-2">
                        <div
                          class="h-4 w-4 rounded"
                          style="background-color: #ae8ad2"
                        ></div>
                        <p
                          class="text-[13px] font-medium leading-[20px] text-dark-2"
                        >
                          Invested amount
                        </p>
                      </div>
                      <p
                        class="font-sm whitespace-nowrap font-semibold text-dark-6"
                      >
                        ₹
                        <!-- -->3,00,000.00
                      </p>
                    </div>
                    <div class="flex flex-col gap-2">
                      <div class="flex items-center gap-2">
                        <div
                          class="h-4 w-4 rounded"
                          style="background-color: #30b48e"
                        ></div>
                        <p
                          class="text-[13px] font-medium leading-[20px] text-dark-2"
                        >
                          Total returns
                        </p>
                      </div>
                      <p
                        class="font-sm whitespace-nowrap font-semibold text-dark-6"
                      >
                        ₹
                        <!-- -->1,12,431.83
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="mt-9 flex flex-col gap-6 md:m-0 md:rounded-b md:border-x md:border-b md:border-grey-7 md:bg-white"
            >
              <div class="flex flex-col gap-5 md:gap-[9px]">
                <div
                  class="flex flex-col md:border-b md:border-grey-7 md:bg-light-1 md:p-3"
                >
                  <p class="text-lg font-semibold text-dark-6 md:text-sm">
                    Year wise return summary
                  </p>
                </div>
                <div
                  class="flex flex-col gap-3 md:flex md:flex-row md:items-center md:justify-between md:gap-4 md:px-4 md:py-2"
                >
                  <div
                    class="flex w-[100%] items-center justify-between py-2 md:gap-[18px] md:py-0"
                  >
                    <p class="text-sm font-medium text-dark-6">
                      SIP
                      <!-- -->
                      payment schedule starting
                    </p>
                    <!-- <div class="upstox-calculator-date-picker">
                      <div class="react-datepicker-wrapper">
                        <div
                          class="react-datepicker__input-container react-datepicker__view-calendar-icon"
                        >
                          <div
                            class="cursor-pointer react-datepicker__calendar-icon date-picker-icon"
                            role="button"
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g id='ð¦ icon "calendar today"'>
                                <path
                                  id="Vector"
                                  d="M16.6667 2.49992H15.8334V0.833252H14.1667V2.49992H5.83341V0.833252H4.16675V2.49992H3.33341C2.41675 2.49992 1.66675 3.24992 1.66675 4.16659V17.4999C1.66675 18.4166 2.41675 19.1666 3.33341 19.1666H16.6667C17.5834 19.1666 18.3334 18.4166 18.3334 17.4999V4.16659C18.3334 3.24992 17.5834 2.49992 16.6667 2.49992ZM16.6667 17.4999H3.33341V6.66659H16.6667V17.4999Z"
                                  fill="#6A6A6A"
                                ></path>
                              </g>
                            </svg>
                          </div>
                          <button
                            class="flex h-9 w-[150px] items-center justify-between rounded-sm border border-solid border-grey-9 bg-light-1 px-2 py-0"
                          >
                            <span
                              class="text-ellipsis text-sm font-normal not-italic leading-5 text-dark-2"
                              >Feb 2025</span
                            >
                          </button>
                        </div>
                      </div>
                    </div> -->
                  </div>
                  <div
                    class="hidden flex w-full items-center justify-between md:flex-1 m-0 bg-light-1"
                  >
                    <div
                      id="scheduleType"
                      class="relative w-full md:min-w-[250px] md:max-w-[250px] bg-light-1 border rounded border-grey-9 font-medium text-sm text-dark-2"
                    >
                      <div
                        class="flex h-[36px] cursor-pointer items-center justify-between rounded border px-2 md:px-3"
                      >
                        <div
                          class="flex items-center text-xs font-medium leading-4"
                        >
                          <span class="mr-2 text-sm">Calendar Year Wise</span>
                        </div>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="24/Chevron Down">
                            <path
                              id="Vector 22"
                              d="M19 9L12 16L5 9"
                              stroke="#262626"
                              stroke-width="2"
                            ></path>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="w-[100%] flex-col md:mt-[1px] md:block md:items-center md:pb-[21px]"
              >
                <!--$--><!--/$-->
                <div>
                  <div class="pl-2 pr-[25px]">
                    <div
                      class="recharts-responsive-container"
                      style="width: 100%; height: 100%; min-width: 0px"
                    >
                      <div
                        class="recharts-wrapper"
                        style="
                          position: relative;
                          cursor: default;
                          width: 100%;
                          height: 100%;
                          max-height: 362.179px;
                          max-width: 565px;
                        "
                      >
                        <svg
                          class="recharts-surface"
                          width="565"
                          height="362.1794871794872"
                          viewBox="0 0 565 362.1794871794872"
                          style="width: 100%; height: 100%"
                        >
                          <title></title>
                          <desc></desc>
                          <defs>
                            <clipPath id="recharts3-clip">
                              <rect
                                x="60"
                                y="0"
                                height="322.1794871794872"
                                width="505"
                              ></rect>
                            </clipPath>
                          </defs>
                          <g class="recharts-cartesian-grid">
                            <g class="recharts-cartesian-grid-horizontal">
                              <line
                                stroke="#E5E5E5"
                                stroke-width="2"
                                fill="none"
                                x="60"
                                y="0"
                                width="505"
                                height="322.1794871794872"
                                x1="60"
                                y1="322.1794871794872"
                                x2="565"
                                y2="322.1794871794872"
                              ></line>
                              <line
                                stroke="#E5E5E5"
                                stroke-width="2"
                                fill="none"
                                x="60"
                                y="0"
                                width="505"
                                height="322.1794871794872"
                                x1="60"
                                y1="241.6346153846154"
                                x2="565"
                                y2="241.6346153846154"
                              ></line>
                              <line
                                stroke="#E5E5E5"
                                stroke-width="2"
                                fill="none"
                                x="60"
                                y="0"
                                width="505"
                                height="322.1794871794872"
                                x1="60"
                                y1="161.0897435897436"
                                x2="565"
                                y2="161.0897435897436"
                              ></line>
                              <line
                                stroke="#E5E5E5"
                                stroke-width="2"
                                fill="none"
                                x="60"
                                y="0"
                                width="505"
                                height="322.1794871794872"
                                x1="60"
                                y1="80.5448717948718"
                                x2="565"
                                y2="80.5448717948718"
                              ></line>
                              <line
                                stroke="#E5E5E5"
                                stroke-width="2"
                                fill="none"
                                x="60"
                                y="0"
                                width="505"
                                height="322.1794871794872"
                                x1="60"
                                y1="0"
                                x2="565"
                                y2="0"
                              ></line>
                            </g>
                            <g class="recharts-cartesian-grid-vertical">
                              <line
                                stroke="#E5E5E5"
                                stroke-width="2"
                                fill="none"
                                x="60"
                                y="0"
                                width="505"
                                height="322.1794871794872"
                                x1="102.08333333333334"
                                y1="0"
                                x2="102.08333333333334"
                                y2="322.1794871794872"
                              ></line>
                              <line
                                stroke="#E5E5E5"
                                stroke-width="2"
                                fill="none"
                                x="60"
                                y="0"
                                width="505"
                                height="322.1794871794872"
                                x1="186.25000000000003"
                                y1="0"
                                x2="186.25000000000003"
                                y2="322.1794871794872"
                              ></line>
                              <line
                                stroke="#E5E5E5"
                                stroke-width="2"
                                fill="none"
                                x="60"
                                y="0"
                                width="505"
                                height="322.1794871794872"
                                x1="270.4166666666667"
                                y1="0"
                                x2="270.4166666666667"
                                y2="322.1794871794872"
                              ></line>
                              <line
                                stroke="#E5E5E5"
                                stroke-width="2"
                                fill="none"
                                x="60"
                                y="0"
                                width="505"
                                height="322.1794871794872"
                                x1="354.5833333333333"
                                y1="0"
                                x2="354.5833333333333"
                                y2="322.1794871794872"
                              ></line>
                              <line
                                stroke="#E5E5E5"
                                stroke-width="2"
                                fill="none"
                                x="60"
                                y="0"
                                width="505"
                                height="322.1794871794872"
                                x1="438.75"
                                y1="0"
                                x2="438.75"
                                y2="322.1794871794872"
                              ></line>
                              <line
                                stroke="#E5E5E5"
                                stroke-width="2"
                                fill="none"
                                x="60"
                                y="0"
                                width="505"
                                height="322.1794871794872"
                                x1="522.9166666666667"
                                y1="0"
                                x2="522.9166666666667"
                                y2="322.1794871794872"
                              ></line>
                              <line
                                stroke="#E5E5E5"
                                stroke-width="2"
                                fill="none"
                                x="60"
                                y="0"
                                width="505"
                                height="322.1794871794872"
                                x1="60"
                                y1="0"
                                x2="60"
                                y2="322.1794871794872"
                              ></line>
                              <line
                                stroke="#E5E5E5"
                                stroke-width="2"
                                fill="none"
                                x="60"
                                y="0"
                                width="505"
                                height="322.1794871794872"
                                x1="565"
                                y1="0"
                                x2="565"
                                y2="322.1794871794872"
                              ></line>
                            </g>
                          </g>
                          <g
                            class="recharts-layer recharts-cartesian-axis recharts-xAxis xAxis axis-ticks"
                          >
                            <line
                              class="recharts-cartesian-axis-line"
                              stroke="#E5E5E5"
                              stroke-width="1"
                              opacity="0.5"
                              orientation="bottom"
                              width="505"
                              height="30"
                              x="60"
                              y="322.1794871794872"
                              fill="none"
                              x1="60"
                              y1="322.1794871794872"
                              x2="565"
                              y2="322.1794871794872"
                            ></line>
                            <g class="recharts-cartesian-axis-ticks">
                              <g
                                class="recharts-layer recharts-cartesian-axis-tick"
                              >
                                <line
                                  class="recharts-cartesian-axis-tick-line"
                                  stroke="#E5E5E5"
                                  stroke-width="1"
                                  opacity="0.5"
                                  orientation="bottom"
                                  width="505"
                                  height="30"
                                  x="60"
                                  y="322.1794871794872"
                                  fill="none"
                                  x1="102.08333333333334"
                                  y1="322.1794871794872"
                                  x2="102.08333333333334"
                                  y2="322.1794871794872"
                                ></line>
                                <text
                                  stroke="none"
                                  stroke-width="1"
                                  opacity="1"
                                  orientation="bottom"
                                  width="505"
                                  height="30"
                                  x="102.08333333333334"
                                  y="333.1794871794872"
                                  class="recharts-text recharts-cartesian-axis-tick-value"
                                  text-anchor="middle"
                                  fill="#6A6A6A"
                                >
                                  <tspan x="102.08333333333334" dy="0.71em">
                                    2025
                                  </tspan>
                                </text>
                              </g>
                              <g
                                class="recharts-layer recharts-cartesian-axis-tick"
                              >
                                <line
                                  class="recharts-cartesian-axis-tick-line"
                                  stroke="#E5E5E5"
                                  stroke-width="1"
                                  opacity="0.5"
                                  orientation="bottom"
                                  width="505"
                                  height="30"
                                  x="60"
                                  y="322.1794871794872"
                                  fill="none"
                                  x1="186.25000000000003"
                                  y1="322.1794871794872"
                                  x2="186.25000000000003"
                                  y2="322.1794871794872"
                                ></line>
                                <text
                                  stroke="none"
                                  stroke-width="1"
                                  opacity="1"
                                  orientation="bottom"
                                  width="505"
                                  height="30"
                                  x="186.25000000000003"
                                  y="333.1794871794872"
                                  class="recharts-text recharts-cartesian-axis-tick-value"
                                  text-anchor="middle"
                                  fill="#6A6A6A"
                                >
                                  <tspan x="186.25000000000003" dy="0.71em">
                                    2026
                                  </tspan>
                                </text>
                              </g>
                              <g
                                class="recharts-layer recharts-cartesian-axis-tick"
                              >
                                <line
                                  class="recharts-cartesian-axis-tick-line"
                                  stroke="#E5E5E5"
                                  stroke-width="1"
                                  opacity="0.5"
                                  orientation="bottom"
                                  width="505"
                                  height="30"
                                  x="60"
                                  y="322.1794871794872"
                                  fill="none"
                                  x1="270.4166666666667"
                                  y1="322.1794871794872"
                                  x2="270.4166666666667"
                                  y2="322.1794871794872"
                                ></line>
                                <text
                                  stroke="none"
                                  stroke-width="1"
                                  opacity="1"
                                  orientation="bottom"
                                  width="505"
                                  height="30"
                                  x="270.4166666666667"
                                  y="333.1794871794872"
                                  class="recharts-text recharts-cartesian-axis-tick-value"
                                  text-anchor="middle"
                                  fill="#6A6A6A"
                                >
                                  <tspan x="270.4166666666667" dy="0.71em">
                                    2027
                                  </tspan>
                                </text>
                              </g>
                              <g
                                class="recharts-layer recharts-cartesian-axis-tick"
                              >
                                <line
                                  class="recharts-cartesian-axis-tick-line"
                                  stroke="#E5E5E5"
                                  stroke-width="1"
                                  opacity="0.5"
                                  orientation="bottom"
                                  width="505"
                                  height="30"
                                  x="60"
                                  y="322.1794871794872"
                                  fill="none"
                                  x1="354.5833333333333"
                                  y1="322.1794871794872"
                                  x2="354.5833333333333"
                                  y2="322.1794871794872"
                                ></line>
                                <text
                                  stroke="none"
                                  stroke-width="1"
                                  opacity="1"
                                  orientation="bottom"
                                  width="505"
                                  height="30"
                                  x="354.5833333333333"
                                  y="333.1794871794872"
                                  class="recharts-text recharts-cartesian-axis-tick-value"
                                  text-anchor="middle"
                                  fill="#6A6A6A"
                                >
                                  <tspan x="354.5833333333333" dy="0.71em">
                                    2028
                                  </tspan>
                                </text>
                              </g>
                              <g
                                class="recharts-layer recharts-cartesian-axis-tick"
                              >
                                <line
                                  class="recharts-cartesian-axis-tick-line"
                                  stroke="#E5E5E5"
                                  stroke-width="1"
                                  opacity="0.5"
                                  orientation="bottom"
                                  width="505"
                                  height="30"
                                  x="60"
                                  y="322.1794871794872"
                                  fill="none"
                                  x1="438.75"
                                  y1="322.1794871794872"
                                  x2="438.75"
                                  y2="322.1794871794872"
                                ></line>
                                <text
                                  stroke="none"
                                  stroke-width="1"
                                  opacity="1"
                                  orientation="bottom"
                                  width="505"
                                  height="30"
                                  x="438.75"
                                  y="333.1794871794872"
                                  class="recharts-text recharts-cartesian-axis-tick-value"
                                  text-anchor="middle"
                                  fill="#6A6A6A"
                                >
                                  <tspan x="438.75" dy="0.71em">2029</tspan>
                                </text>
                              </g>
                              <g
                                class="recharts-layer recharts-cartesian-axis-tick"
                              >
                                <line
                                  class="recharts-cartesian-axis-tick-line"
                                  stroke="#E5E5E5"
                                  stroke-width="1"
                                  opacity="0.5"
                                  orientation="bottom"
                                  width="505"
                                  height="30"
                                  x="60"
                                  y="322.1794871794872"
                                  fill="none"
                                  x1="522.9166666666667"
                                  y1="322.1794871794872"
                                  x2="522.9166666666667"
                                  y2="322.1794871794872"
                                ></line>
                                <text
                                  stroke="none"
                                  stroke-width="1"
                                  opacity="1"
                                  orientation="bottom"
                                  width="505"
                                  height="30"
                                  x="522.9166666666667"
                                  y="333.1794871794872"
                                  class="recharts-text recharts-cartesian-axis-tick-value"
                                  text-anchor="middle"
                                  fill="#6A6A6A"
                                >
                                  <tspan x="522.9166666666667" dy="0.71em">
                                    2030
                                  </tspan>
                                </text>
                              </g>
                            </g>
                            <text
                              offset="0"
                              x="312.5"
                              y="361.1794871794872"
                              class="recharts-text axis-label"
                              text-anchor="middle"
                              fill="000"
                            >
                              <tspan x="312.5" dy="0em">Year</tspan>
                            </text>
                          </g>
                          <g
                            class="recharts-layer recharts-cartesian-axis recharts-yAxis yAxis axis-ticks"
                          >
                            <line
                              class="recharts-cartesian-axis-line"
                              stroke="#E5E5E5"
                              stroke-width="1"
                              opacity="0.5"
                              orientation="left"
                              width="60"
                              height="322.1794871794872"
                              x="0"
                              y="0"
                              fill="none"
                              x1="60"
                              y1="0"
                              x2="60"
                              y2="322.1794871794872"
                            ></line>
                            <g class="recharts-cartesian-axis-ticks">
                              <g
                                class="recharts-layer recharts-cartesian-axis-tick"
                              >
                                <line
                                  class="recharts-cartesian-axis-tick-line"
                                  stroke="#E5E5E5"
                                  stroke-width="2"
                                  opacity="0.5"
                                  orientation="left"
                                  width="60"
                                  height="322.1794871794872"
                                  x="0"
                                  y="0"
                                  fill="none"
                                  x1="54"
                                  y1="322.1794871794872"
                                  x2="60"
                                  y2="322.1794871794872"
                                ></line>
                                <text
                                  stroke="none"
                                  stroke-width="1"
                                  opacity="1"
                                  orientation="left"
                                  width="60"
                                  height="322.1794871794872"
                                  x="50"
                                  y="322.1794871794872"
                                  class="recharts-text recharts-cartesian-axis-tick-value"
                                  text-anchor="end"
                                  fill="#6A6A6A"
                                >
                                  <tspan x="50" dy="0.355em">0</tspan>
                                </text>
                              </g>
                              <g
                                class="recharts-layer recharts-cartesian-axis-tick"
                              >
                                <line
                                  class="recharts-cartesian-axis-tick-line"
                                  stroke="#E5E5E5"
                                  stroke-width="2"
                                  opacity="0.5"
                                  orientation="left"
                                  width="60"
                                  height="322.1794871794872"
                                  x="0"
                                  y="0"
                                  fill="none"
                                  x1="54"
                                  y1="241.6346153846154"
                                  x2="60"
                                  y2="241.6346153846154"
                                ></line>
                                <text
                                  stroke="none"
                                  stroke-width="1"
                                  opacity="1"
                                  orientation="left"
                                  width="60"
                                  height="322.1794871794872"
                                  x="50"
                                  y="241.6346153846154"
                                  class="recharts-text recharts-cartesian-axis-tick-value"
                                  text-anchor="end"
                                  fill="#6A6A6A"
                                >
                                  <tspan x="50" dy="0.355em">₹ 2L</tspan>
                                </text>
                              </g>
                              <g
                                class="recharts-layer recharts-cartesian-axis-tick"
                              >
                                <line
                                  class="recharts-cartesian-axis-tick-line"
                                  stroke="#E5E5E5"
                                  stroke-width="2"
                                  opacity="0.5"
                                  orientation="left"
                                  width="60"
                                  height="322.1794871794872"
                                  x="0"
                                  y="0"
                                  fill="none"
                                  x1="54"
                                  y1="161.0897435897436"
                                  x2="60"
                                  y2="161.0897435897436"
                                ></line>
                                <text
                                  stroke="none"
                                  stroke-width="1"
                                  opacity="1"
                                  orientation="left"
                                  width="60"
                                  height="322.1794871794872"
                                  x="50"
                                  y="161.0897435897436"
                                  class="recharts-text recharts-cartesian-axis-tick-value"
                                  text-anchor="end"
                                  fill="#6A6A6A"
                                >
                                  <tspan x="50" dy="0.355em">₹ 3L</tspan>
                                </text>
                              </g>
                              <g
                                class="recharts-layer recharts-cartesian-axis-tick"
                              >
                                <line
                                  class="recharts-cartesian-axis-tick-line"
                                  stroke="#E5E5E5"
                                  stroke-width="2"
                                  opacity="0.5"
                                  orientation="left"
                                  width="60"
                                  height="322.1794871794872"
                                  x="0"
                                  y="0"
                                  fill="none"
                                  x1="54"
                                  y1="80.5448717948718"
                                  x2="60"
                                  y2="80.5448717948718"
                                ></line>
                                <text
                                  stroke="none"
                                  stroke-width="1"
                                  opacity="1"
                                  orientation="left"
                                  width="60"
                                  height="322.1794871794872"
                                  x="50"
                                  y="80.5448717948718"
                                  class="recharts-text recharts-cartesian-axis-tick-value"
                                  text-anchor="end"
                                  fill="#6A6A6A"
                                >
                                  <tspan x="50" dy="0.355em">₹ 5L</tspan>
                                </text>
                              </g>
                              <g
                                class="recharts-layer recharts-cartesian-axis-tick"
                              >
                                <line
                                  class="recharts-cartesian-axis-tick-line"
                                  stroke="#E5E5E5"
                                  stroke-width="2"
                                  opacity="0.5"
                                  orientation="left"
                                  width="60"
                                  height="322.1794871794872"
                                  x="0"
                                  y="0"
                                  fill="none"
                                  x1="54"
                                  y1="0"
                                  x2="60"
                                  y2="0"
                                ></line>
                                <text
                                  stroke="none"
                                  stroke-width="1"
                                  opacity="1"
                                  orientation="left"
                                  width="60"
                                  height="322.1794871794872"
                                  x="50"
                                  y="7.5"
                                  class="recharts-text recharts-cartesian-axis-tick-value"
                                  text-anchor="end"
                                  fill="#6A6A6A"
                                >
                                  <tspan x="50" dy="0.355em">₹ 6L</tspan>
                                </text>
                              </g>
                            </g>
                            <text
                              offset="5"
                              transform="rotate(-90, 5, 161.0897435897436)"
                              x="5"
                              y="161.0897435897436"
                              class="recharts-text axis-label"
                              text-anchor="start"
                              fill="000"
                            >
                              <tspan x="5" dy="0.355em">Returns</tspan>
                            </text>
                          </g>
                          <g class="recharts-layer recharts-bar">
                            <g class="recharts-layer recharts-bar-rectangles">
                              <g class="recharts-layer">
                                <g
                                  class="recharts-layer recharts-bar-rectangle"
                                >
                                  <path
                                    x="89.91666666666667"
                                    y="292.6463675213675"
                                    width="24"
                                    height="29.533119658119688"
                                    radius="0"
                                    fill="#AE8AD1"
                                    class="recharts-rectangle"
                                    d="M 89.91666666666667,292.6463675213675 h 24 v 29.533119658119688 h -24 Z"
                                  ></path>
                                </g>
                                <g
                                  class="recharts-layer recharts-bar-rectangle"
                                >
                                  <path
                                    x="174.08333333333334"
                                    y="260.4284188034188"
                                    width="24"
                                    height="61.75106837606836"
                                    radius="0"
                                    fill="#AE8AD1"
                                    class="recharts-rectangle"
                                    d="M 174.08333333333334,260.4284188034188 h 24 v 61.75106837606836 h -24 Z"
                                  ></path>
                                </g>
                                <g
                                  class="recharts-layer recharts-bar-rectangle"
                                >
                                  <path
                                    x="258.25"
                                    y="228.21047008547006"
                                    width="24"
                                    height="93.96901709401712"
                                    radius="0"
                                    fill="#AE8AD1"
                                    class="recharts-rectangle"
                                    d="M 258.25,228.21047008547006 h 24 v 93.96901709401712 h -24 Z"
                                  ></path>
                                </g>
                                <g
                                  class="recharts-layer recharts-bar-rectangle"
                                >
                                  <path
                                    x="342.4166666666667"
                                    y="195.9925213675214"
                                    width="24"
                                    height="126.18696581196579"
                                    radius="0"
                                    fill="#AE8AD1"
                                    class="recharts-rectangle"
                                    d="M 342.4166666666667,195.9925213675214 h 24 v 126.18696581196579 h -24 Z"
                                  ></path>
                                </g>
                                <g
                                  class="recharts-layer recharts-bar-rectangle"
                                >
                                  <path
                                    x="426.58333333333337"
                                    y="163.77457264957263"
                                    width="24"
                                    height="158.40491452991455"
                                    radius="0"
                                    fill="#AE8AD1"
                                    class="recharts-rectangle"
                                    d="M 426.58333333333337,163.77457264957263 h 24 v 158.40491452991455 h -24 Z"
                                  ></path>
                                </g>
                                <g
                                  class="recharts-layer recharts-bar-rectangle"
                                >
                                  <path
                                    x="510.75000000000006"
                                    y="161.0897435897436"
                                    width="24"
                                    height="161.0897435897436"
                                    radius="0"
                                    fill="#AE8AD1"
                                    class="recharts-rectangle"
                                    d="M 510.75000000000006,161.0897435897436 h 24 v 161.0897435897436 h -24 Z"
                                  ></path>
                                </g>
                              </g>
                            </g>
                            <g class="recharts-layer"></g>
                          </g>
                          <g class="recharts-layer recharts-bar">
                            <g class="recharts-layer recharts-bar-rectangles">
                              <g class="recharts-layer">
                                <g
                                  class="recharts-layer recharts-bar-rectangle"
                                >
                                  <path
                                    x="89.91666666666667"
                                    y="290.81396359811544"
                                    width="24"
                                    height="1.832403923252059"
                                    radius="2,2,0,0"
                                    fill="#30B48E"
                                    class="recharts-rectangle"
                                    d="M89.91666666666667,291.73016555974147A 0.9162019616260295,0.9162019616260295,0,0,1,90.8328686282927,290.81396359811544L 113.00046470504064,290.81396359811544A 0.9162019616260295,0.9162019616260295,0,0,1,
        113.91666666666667,291.73016555974147L 113.91666666666667,292.6463675213675L 89.91666666666667,292.6463675213675Z"
                                  ></path>
                                </g>
                                <g
                                  class="recharts-layer recharts-bar-rectangle"
                                >
                                  <path
                                    x="174.08333333333334"
                                    y="252.44517395719006"
                                    width="24"
                                    height="7.983244846228757"
                                    radius="2,2,0,0"
                                    fill="#30B48E"
                                    class="recharts-rectangle"
                                    d="M174.08333333333334,254.44517395719006A 2,2,0,0,1,176.08333333333334,252.44517395719006L 196.08333333333334,252.44517395719006A 2,2,0,0,1,
        198.08333333333334,254.44517395719006L 198.08333333333334,260.4284188034188L 174.08333333333334,260.4284188034188Z"
                                  ></path>
                                </g>
                                <g
                                  class="recharts-layer recharts-bar-rectangle"
                                >
                                  <path
                                    x="258.25"
                                    y="209.21026141392716"
                                    width="24"
                                    height="19.000208671542907"
                                    radius="2,2,0,0"
                                    fill="#30B48E"
                                    class="recharts-rectangle"
                                    d="M258.25,211.21026141392716A 2,2,0,0,1,260.25,209.21026141392716L 280.25,209.21026141392716A 2,2,0,0,1,
        282.25,211.21026141392716L 282.25,228.21047008547006L 258.25,228.21047008547006Z"
                                  ></path>
                                </g>
                                <g
                                  class="recharts-layer recharts-bar-rectangle"
                                >
                                  <path
                                    x="342.4166666666667"
                                    y="160.49207978461183"
                                    width="24"
                                    height="35.50044158290956"
                                    radius="2,2,0,0"
                                    fill="#30B48E"
                                    class="recharts-rectangle"
                                    d="M342.4166666666667,162.49207978461183A 2,2,0,0,1,344.4166666666667,160.49207978461183L 364.4166666666667,160.49207978461183A 2,2,0,0,1,
        366.4166666666667,162.49207978461183L 366.4166666666667,195.9925213675214L 342.4166666666667,195.9925213675214Z"
                                  ></path>
                                </g>
                                <g
                                  class="recharts-layer recharts-bar-rectangle"
                                >
                                  <path
                                    x="426.58333333333337"
                                    y="105.59521330218388"
                                    width="24"
                                    height="58.179359347388754"
                                    radius="2,2,0,0"
                                    fill="#30B48E"
                                    class="recharts-rectangle"
                                    d="M426.58333333333337,107.59521330218388A 2,2,0,0,1,428.58333333333337,105.59521330218388L 448.58333333333337,105.59521330218388A 2,2,0,0,1,
        450.58333333333337,107.59521330218388L 450.58333333333337,163.77457264957263L 426.58333333333337,163.77457264957263Z"
                                  ></path>
                                </g>
                                <g
                                  class="recharts-layer recharts-bar-rectangle"
                                >
                                  <path
                                    x="510.75000000000006"
                                    y="100.71769321298349"
                                    width="24"
                                    height="60.3720503767601"
                                    radius="2,2,0,0"
                                    fill="#30B48E"
                                    class="recharts-rectangle"
                                    d="M510.75000000000006,102.71769321298349A 2,2,0,0,1,512.75,100.71769321298349L 532.75,100.71769321298349A 2,2,0,0,1,
        534.75,102.71769321298349L 534.75,161.0897435897436L 510.75000000000006,161.0897435897436Z"
                                  ></path>
                                </g>
                              </g>
                            </g>
                            <g class="recharts-layer"></g>
                          </g>
                        </svg>
                        <div
                          tabindex="-1"
                          class="recharts-tooltip-wrapper"
                          style="
                            visibility: hidden;
                            pointer-events: none;
                            position: absolute;
                            top: 0px;
                            left: 0px;
                          "
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div class="flex items-center justify-center gap-[100px]">
                    <div class="mt-4 flex items-center gap-2">
                      <div
                        class="h-4 w-4 rounded-[2px]"
                        style="background-color: rgb(48, 180, 142)"
                      ></div>
                      <p class="text-sm font-medium text-dark-2">
                        Total returns
                      </p>
                    </div>
                    <div class="mt-4 flex items-center gap-2">
                      <div
                        class="h-4 w-4 rounded-[2px]"
                        style="background-color: rgb(174, 138, 209)"
                      ></div>
                      <p class="text-sm font-medium text-dark-2">
                        Total invested amount
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-6">
              <!--$-->
              <div class="no-scrollbar overflow-x-auto">
                <div class="min-w-[600px]">
                  <table
                    class="w-full border-separate border-spacing-0 rounded-2xl border border-gray-200 text-center"
                  >
                    <thead>
                      <tr class="text-center">
                        <th
                          class="not-italic text-center border-r last:border-r-0 border-gray-200 h-[57px] text-sm font-medium border-t-0 text-dark-6 md:min-w-[119px] w-[90px]"
                        >
                          Year
                        </th>
                        <th
                          class="not-italic text-center border-r last:border-r-0 border-gray-200 h-[57px] text-sm font-medium border-t-0 text-dark-6 min-w-[120px]"
                        >
                          Cumulative Investment
                        </th>
                        <th
                          class="not-italic text-center border-r last:border-r-0 border-gray-200 h-[57px] text-sm font-medium border-t-0 text-dark-6 min-w-[120px]"
                        >
                          Cumulative <br />
                          return
                        </th>
                        <th
                          class="not-italic text-center border-r last:border-r-0 border-gray-200 h-[57px] text-sm font-medium border-t-0 text-dark-6 min-w-[120px]"
                        >
                          Cumulative <br />
                          return %
                        </th>
                        <th
                          class="not-italic text-center border-r last:border-r-0 border-gray-200 h-[57px] text-sm font-medium border-t-0 text-dark-6 min-w-[119px]"
                        >
                          Total value of <br />
                          investment
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="text-center">
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200 flex items-center justify-center"
                        >
                          <button
                            class="ml-2 mr-2 w-[14px] !bg-transparent hidden"
                          >
                            <img
                              alt="expandRow"
                              loading="lazy"
                              width="14"
                              height="14"
                              decoding="async"
                              data-nimg="1"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/expandRow.svg"
                            /></button
                          ><span class="pr-2">2025</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹55,000.00</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹3,412.52</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">6.20%</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹58,412.52</span>
                        </td>
                      </tr>
                      <tr class="text-center">
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200 flex items-center justify-center"
                        >
                          <button
                            class="ml-2 mr-2 w-[14px] !bg-transparent hidden"
                          >
                            <img
                              alt="expandRow"
                              loading="lazy"
                              width="14"
                              height="14"
                              decoding="async"
                              data-nimg="1"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/expandRow.svg"
                            /></button
                          ><span class="pr-2">2026</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹1,15,000.00</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹14,867.32</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">12.93%</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹1,29,867.32</span>
                        </td>
                      </tr>
                      <tr class="text-center">
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200 flex items-center justify-center"
                        >
                          <button
                            class="ml-2 mr-2 w-[14px] !bg-transparent hidden"
                          >
                            <img
                              alt="expandRow"
                              loading="lazy"
                              width="14"
                              height="14"
                              decoding="async"
                              data-nimg="1"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/expandRow.svg"
                            /></button
                          ><span class="pr-2">2027</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹1,75,000.00</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹35,384.39</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">20.22%</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹2,10,384.39</span>
                        </td>
                      </tr>
                      <tr class="text-center">
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200 flex items-center justify-center"
                        >
                          <button
                            class="ml-2 mr-2 w-[14px] !bg-transparent hidden"
                          >
                            <img
                              alt="expandRow"
                              loading="lazy"
                              width="14"
                              height="14"
                              decoding="async"
                              data-nimg="1"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/expandRow.svg"
                            /></button
                          ><span class="pr-2">2028</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹2,35,000.00</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹66,113.04</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">28.13%</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹3,01,113.04</span>
                        </td>
                      </tr>
                      <tr class="text-center">
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200 flex items-center justify-center"
                        >
                          <button
                            class="ml-2 mr-2 w-[14px] !bg-transparent hidden"
                          >
                            <img
                              alt="expandRow"
                              loading="lazy"
                              width="14"
                              height="14"
                              decoding="async"
                              data-nimg="1"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/expandRow.svg"
                            /></button
                          ><span class="pr-2">2029</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹2,95,000.00</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹1,08,348.35</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">36.73%</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹4,03,348.35</span>
                        </td>
                      </tr>
                      <tr class="text-center">
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200 flex items-center justify-center"
                        >
                          <button
                            class="ml-2 mr-2 w-[14px] !bg-transparent hidden"
                          >
                            <img
                              alt="expandRow"
                              loading="lazy"
                              width="14"
                              height="14"
                              decoding="async"
                              data-nimg="1"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/expandRow.svg"
                            /></button
                          ><span class="pr-2">2030</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹3,00,000.00</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹1,12,431.83</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">37.48%</span>
                        </td>
                        <td
                          class="h-[57px] text-sm not-italic font-normal leading-5 text-grey-8 border-r border-t last:border-r-0 border-gray-200"
                        >
                          <span class="px-2">₹4,12,431.83</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!--/$-->
            </div>
            <hr class="my-6 h-px border-0 bg-grey-7" />
            <div class="flex flex-col gap-4">
              <p class="text-lg font-semibold leading-[26px] text-dark-6">
                Top
                <!-- -->SIP<!-- -->
                Mutual Funds
              </p>
              <a
                target="_blank"
                href="/mutual-funds/mirae-asset-nyse-fang-etf-fund-of-fund-direct-growth-details-104456"
                ><div
                  class="relative w-full min-w-[328px] rounded-xl bg-gray-light p-4 md:ml-0 md:flex md:w-auto md:gap-x-5 md:px-4 md:py-6"
                >
                  <div
                    class="mb-4 flex h-[64px] gap-4 md:mb-0 md:w-[185px] md:items-center md:gap-2"
                  >
                    <img
                      alt="index-mutual-fund"
                      loading="lazy"
                      width="40"
                      height="40"
                      decoding="async"
                      data-nimg="1"
                      class="h-[40px] w-[40px] rounded-full md:h-[32px] md:w-[32px]"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/fundhouse/0C0000BRKM.png"
                    />
                    <div class="md:flex md:flex-col md:gap-y-2">
                      <div
                        class="line-clamp-2 w-[224px] text-base font-bold text-dark-1 md:w-[145px] md:text-sm md:font-semibold md:text-[#000000]"
                      >
                        Mirae Asset NYSE FANG+ ETF Fund of Fund
                      </div>
                      <div
                        class="text-xs font-medium text-light-6 md:text-dark-2"
                      >
                        <span>Equity</span><span class="mx-1">•</span
                        ><span>Global - Other</span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex flex-wrap gap-y-4 md:flex-1 md:flex-nowrap md:items-center md:justify-between"
                  >
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >3Y CAGR</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >42.54%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Expense Ratio</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >0.68%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Tracking error</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap"></span>NA</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >AUM (in ₹Cr)</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap">₹2010.4</span></span
                      >
                    </div>
                  </div>
                </div></a
              ><a
                target="_blank"
                href="/mutual-funds/bank-of-india-credit-risk-fund-direct-growth-details-105889"
                ><div
                  class="relative w-full min-w-[328px] rounded-xl bg-gray-light p-4 md:ml-0 md:flex md:w-auto md:gap-x-5 md:px-4 md:py-6"
                >
                  <div
                    class="mb-4 flex h-[64px] gap-4 md:mb-0 md:w-[185px] md:items-center md:gap-2"
                  >
                    <img
                      alt="index-mutual-fund"
                      loading="lazy"
                      width="40"
                      height="40"
                      decoding="async"
                      data-nimg="1"
                      class="h-[40px] w-[40px] rounded-full md:h-[32px] md:w-[32px]"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/fundhouse/0C00001UQY.png"
                    />
                    <div class="md:flex md:flex-col md:gap-y-2">
                      <div
                        class="line-clamp-2 w-[224px] text-base font-bold text-dark-1 md:w-[145px] md:text-sm md:font-semibold md:text-[#000000]"
                      >
                        Bank of India Credit Risk Fund
                      </div>
                      <div
                        class="text-xs font-medium text-light-6 md:text-dark-2"
                      >
                        <span>Debt</span><span class="mx-1">•</span
                        ><span>Credit Risk</span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex flex-wrap gap-y-4 md:flex-1 md:flex-nowrap md:items-center md:justify-between"
                  >
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >3Y CAGR</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >37.66%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Expense Ratio</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >0.98%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Tracking error</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap"></span>NA</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >AUM (in ₹Cr)</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap">₹113.6</span></span
                      >
                    </div>
                  </div>
                </div></a
              ><a
                target="_blank"
                href="/mutual-funds/sbi-psu-direct-growth-details-105051"
                ><div
                  class="relative w-full min-w-[328px] rounded-xl bg-gray-light p-4 md:ml-0 md:flex md:w-auto md:gap-x-5 md:px-4 md:py-6"
                >
                  <div
                    class="mb-4 flex h-[64px] gap-4 md:mb-0 md:w-[185px] md:items-center md:gap-2"
                  >
                    <img
                      alt="index-mutual-fund"
                      loading="lazy"
                      width="40"
                      height="40"
                      decoding="async"
                      data-nimg="1"
                      class="h-[40px] w-[40px] rounded-full md:h-[32px] md:w-[32px]"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/fundhouse/0C00003HJY.png"
                    />
                    <div class="md:flex md:flex-col md:gap-y-2">
                      <div
                        class="line-clamp-2 w-[224px] text-base font-bold text-dark-1 md:w-[145px] md:text-sm md:font-semibold md:text-[#000000]"
                      >
                        SBI PSU
                      </div>
                      <div
                        class="text-xs font-medium text-light-6 md:text-dark-2"
                      >
                        <span>Equity</span><span class="mx-1">•</span
                        ><span>Other</span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex flex-wrap gap-y-4 md:flex-1 md:flex-nowrap md:items-center md:justify-between"
                  >
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >3Y CAGR</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >30.91%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Expense Ratio</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >0.78%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Tracking error</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap"></span>NA</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >AUM (in ₹Cr)</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap">₹4542.8</span></span
                      >
                    </div>
                  </div>
                </div></a
              ><a
                target="_blank"
                href="/mutual-funds/icici-prudential-infrastructure-fund-direct-growth-details-100042"
                ><div
                  class="relative w-full min-w-[328px] rounded-xl bg-gray-light p-4 md:ml-0 md:flex md:w-auto md:gap-x-5 md:px-4 md:py-6"
                >
                  <div
                    class="mb-4 flex h-[64px] gap-4 md:mb-0 md:w-[185px] md:items-center md:gap-2"
                  >
                    <img
                      alt="index-mutual-fund"
                      loading="lazy"
                      width="40"
                      height="40"
                      decoding="async"
                      data-nimg="1"
                      class="h-[40px] w-[40px] rounded-full md:h-[32px] md:w-[32px]"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/fundhouse/0C0000953D.png"
                    />
                    <div class="md:flex md:flex-col md:gap-y-2">
                      <div
                        class="line-clamp-2 w-[224px] text-base font-bold text-dark-1 md:w-[145px] md:text-sm md:font-semibold md:text-[#000000]"
                      >
                        ICICI Prudential Infrastructure Fund
                      </div>
                      <div
                        class="text-xs font-medium text-light-6 md:text-dark-2"
                      >
                        <span>Equity</span><span class="mx-1">•</span
                        ><span>Infrastructure</span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex flex-wrap gap-y-4 md:flex-1 md:flex-nowrap md:items-center md:justify-between"
                  >
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >3Y CAGR</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >28.87%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Expense Ratio</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >1.15%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Tracking error</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap"></span>NA</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >AUM (in ₹Cr)</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap">₹6910.5</span></span
                      >
                    </div>
                  </div>
                </div></a
              ><a
                target="_blank"
                href="/mutual-funds/motilal-oswal-midcap-fund-direct-growth-details-104974"
                ><div
                  class="relative w-full min-w-[328px] rounded-xl bg-gray-light p-4 md:ml-0 md:flex md:w-auto md:gap-x-5 md:px-4 md:py-6"
                >
                  <div
                    class="mb-4 flex h-[64px] gap-4 md:mb-0 md:w-[185px] md:items-center md:gap-2"
                  >
                    <img
                      alt="index-mutual-fund"
                      loading="lazy"
                      width="40"
                      height="40"
                      decoding="async"
                      data-nimg="1"
                      class="h-[40px] w-[40px] rounded-full md:h-[32px] md:w-[32px]"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/fundhouse/0C0000563U.png"
                    />
                    <div class="md:flex md:flex-col md:gap-y-2">
                      <div
                        class="line-clamp-2 w-[224px] text-base font-bold text-dark-1 md:w-[145px] md:text-sm md:font-semibold md:text-[#000000]"
                      >
                        Motilal Oswal Midcap Fund
                      </div>
                      <div
                        class="text-xs font-medium text-light-6 md:text-dark-2"
                      >
                        <span>Equity</span><span class="mx-1">•</span
                        ><span>Mid-Cap</span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex flex-wrap gap-y-4 md:flex-1 md:flex-nowrap md:items-center md:justify-between"
                  >
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >3Y CAGR</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >28.87%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Expense Ratio</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >0.65%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Tracking error</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap"></span>NA</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >AUM (in ₹Cr)</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap">₹26421.1</span></span
                      >
                    </div>
                  </div>
                  <img
                    alt="top-rated"
                    loading="lazy"
                    width="18"
                    height="50"
                    decoding="async"
                    data-nimg="1"
                    class="absolute right-[8px] top-[-3px] md:left-[13px] md:top-[-16px] md:-rotate-90"
                    style="color: transparent"
                    src="@/styles/img/calculator/next-calculator-assets/top-rated.svg"
                  /></div></a
              ><a
                target="_blank"
                href="/mutual-funds/hdfc-infrastructure-fund-direct-growth-details-100119"
                ><div
                  class="relative w-full min-w-[328px] rounded-xl bg-gray-light p-4 md:ml-0 md:flex md:w-auto md:gap-x-5 md:px-4 md:py-6"
                >
                  <div
                    class="mb-4 flex h-[64px] gap-4 md:mb-0 md:w-[185px] md:items-center md:gap-2"
                  >
                    <img
                      alt="index-mutual-fund"
                      loading="lazy"
                      width="40"
                      height="40"
                      decoding="async"
                      data-nimg="1"
                      class="h-[40px] w-[40px] rounded-full md:h-[32px] md:w-[32px]"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/fundhouse/0C00009534.png"
                    />
                    <div class="md:flex md:flex-col md:gap-y-2">
                      <div
                        class="line-clamp-2 w-[224px] text-base font-bold text-dark-1 md:w-[145px] md:text-sm md:font-semibold md:text-[#000000]"
                      >
                        HDFC Infrastructure Fund
                      </div>
                      <div
                        class="text-xs font-medium text-light-6 md:text-dark-2"
                      >
                        <span>Equity</span><span class="mx-1">•</span
                        ><span>Infrastructure</span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex flex-wrap gap-y-4 md:flex-1 md:flex-nowrap md:items-center md:justify-between"
                  >
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >3Y CAGR</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >28.83%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Expense Ratio</span
                      ><span
                        class="text-sm font-medium text-dark-1 md:font-semibold md:text-black"
                        >1.07%</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pr-2 md:w-auto md:items-center md:pr-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >Tracking error</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap"></span>NA</span
                      >
                    </div>
                    <div
                      class="flex w-[50%] flex-col pl-2 md:w-auto md:items-center md:pl-0"
                    >
                      <span
                        class="whitespace-nowrap text-xs font-medium text-gray-accent3 md:mb-2 md:text-dark-1"
                        >AUM (in ₹Cr)</span
                      ><span
                        class="flex text-sm font-medium md:font-semibold md:text-black"
                        ><span class="whitespace-nowrap">₹2341.1</span></span
                      >
                    </div>
                  </div>
                </div></a
              >
            </div>
            <div class="emi-seo-content mt-6">
              <h2>What is SIP?</h2>

              <p>
                A Systematic Investment Plan (SIP) allows you to invest little
                amounts of money in mutual funds on a monthly basis rather than
                a lumpsum amount. This strategy helps to average out investment
                costs and gains from compounding growth. SIPs are flexible
                allowing you to choose the amount and duration as per your
                financial goals.
              </p>

              <h2>What is SIP Calculator?</h2>

              <p>
                If you are planning to put your money in mutual funds, an online
                SIP calculator could be helpful in deciding the amount you need
                to invest for building a certain corpus fund. A SIP calculator
                is an online tool that allows investors to assess the possible
                returns of a Systematic Investment Plan (SIP) in mutual funds.
              </p>

              <h2>How do SIP Calculators work?</h2>

              <p>
                The SIP Calculator is a free, user-friendly tool available for
                all. It instantly calculates the value of your investments over
                a period of time. You can check how your wealth will grow by
                simply entering the SIP amount, expected rate of return, and the
                duration of investment.
              </p>

              <p>
                The SIP calculators use a simple formula to compute the
                estimated returns:
              </p>

              <p>
                <code>FV = [P x R x (1 + i)<sup>n-1</sup>/i] x (1 + i)</code>
              </p>

              <p>Where:</p>
              <ul>
                <li>
                  <strong>FV</strong> is the future value of your investment
                </li>
                <li><strong>‘i’</strong> is the compounded rate of return</li>
                <li><strong>‘R’</strong> is the expected rate of return</li>
                <li><strong>‘P’</strong> is the SIP amount</li>
                <li><strong>‘n’</strong> is the number of instalments</li>
              </ul>

              <h2>Benefits of investing through SIP</h2>

              <ul>
                <li>
                  SIP investments help to inculcate financial discipline by
                  promoting regular savings.
                </li>
                <li>
                  You can build a large corpus through small investments every
                  month.
                </li>
                <li>
                  The SIP investments offer you the flexibility to increase or
                  decrease the amount as per your needs or financial conditions.
                </li>
                <li>
                  SIP investments are convenient to start as you can begin with
                  a monthly amount of ₹500. Even many schemes allow SIP with a
                  minimum amount of ₹100 per month.
                </li>
              </ul>

              <h2>Advantages of Using SIP Calculator</h2>

              <ul>
                <li>It is simple and free, with unlimited access.</li>
                <li>Provides a transparent view of potential returns.</li>
                <li>Automates complex calculations.</li>
                <li>
                  Helps plan monthly investments to meet financial targets.
                </li>
              </ul>

              <h2>How to use online SIP Calculators</h2>

              <p>
                It’s easy and simple to use an online SIP Calculator. Open the
                webpage of the SIP Calculator and enter the following details:
              </p>
              <ul>
                <li>Monthly investment amount</li>
                <li>Duration of the investment</li>
                <li>Expected rate of return</li>
              </ul>

              <p>
                The SIP calculator will show the total amount along with the
                interest earnings.
              </p>

              <h2>How Can SIP Calculators Help You?</h2>

              <p>
                A SIP return calculator helps you estimate how much your
                investments can grow over time with regular contributions. It
                allows you to see potential future returns based on how much you
                invest each month, for how long, and at what rate. This provides
                you necessary information to plan your finances, set realistic
                goals, and make informed decisions about your investments. By
                using the calculator, you can also compare different investment
                scenarios and track your progress toward your financial goals.
              </p>

              <p class="example-heading">Examples of SIP Growth</p>

              <div>
                <p class="example-heading">Example 1:</p>
                <p>Monthly Investment: ₹5,000</p>
                <p>Duration: 10 years</p>
                <p>Expected Annual Rate of Return: 14%</p>
                <p>
                  Total Investment: ₹5,000 × 12 months × 10 years = ₹6,00,000
                </p>
                <p>Estimated interest earnings: ₹7,10,457</p>
                <p>Future Value: Approximately ₹13,10,457</p>
              </div>

              <div>
                <p class="example-heading">Example 2:</p>
                <p>Monthly Investment: ₹10,000</p>
                <p>Duration: 10 years</p>
                <p>Expected Annual Rate of Return: 14%</p>
                <p>
                  Total Investment: ₹10,000 × 12 months × 10 years = ₹12,00,000
                </p>
                <p>Estimated interest earnings: ₹14,20,914</p>
                <p>Future Value: Approximately ₹26,20,914</p>
              </div>
            </div>
            <div class="pt-6">
              <span
                class="text-xl font-semibold not-italic leading-7 text-dark-1"
                >Frequently asked questions</span
              >
              <div class="pt-6">
                <div class="mb-4 border-b border-b-light-4 pb-4 last:border-0">
                  <div>
                    <div class="cursor-pointer" @click="changeTab(-1)">
                      <div
                        class="group flex w-full items-start justify-between px-0 py-2 text-left leading-10 md:items-center"
                        :data-state="tab===-1?'open':'closed'"
                      >
                        <div
                          class="inter-display-font flex w-full items-center justify-between"
                        >
                          <h3
                            class="w-full tracking-[-0.24px] text-base not-italic font-semibold leading-6 text-dark-6"
                          >
                            Are SIP investments tax-free?
                          </h3>
                          
                          <span class="ml-2 flex-shrink-0 text-lg font-bold"
                            ><img
                              alt="Chevron"
                              loading="lazy"
                              width="24"
                              height="24"
                              decoding="async"
                              data-nimg="1"
                              class="group-data-[state=open]:rotate-180"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg" /></span>
                        </div>
                      </div>
                    </div>
                    <div
                      ref="content11"
                      class="overflow-hidden transition-all duration-300 ease-in-out block"
                      :style="{maxHeight: tab===-1?content11.scrollHeight+'px':'0px'}"
                    >
                      <div
                        class="flex flex-col justify-between pb-2 pt-1 tracking-[-0.14px] desktop-sm:flex-row text-sm not-italic font-normal leading-5 text-grey-8"
                      >
                        SIPs generally are not tax-free, but investing in the
                        ELSS funds can offer tax benefits under Section 80C of
                        the Income Tax Act, 1961.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-4 border-b border-b-light-4 pb-4 last:border-0">
                  <div>
                    <div class="cursor-pointer" @click="changeTab(0)">
                      <div
                        class="group flex w-full items-start justify-between px-0 py-2 text-left leading-10 md:items-center"
                        :data-state="tab===0?'open':'closed'"
                      >
                        <div
                          class="inter-display-font flex w-full items-center justify-between"
                        >
                          <h3
                            class="w-full tracking-[-0.24px] text-base not-italic font-semibold leading-6 text-dark-6"
                          >
                            Is SIP suitable for all investors?
                          </h3>
                          
                          <span class="ml-2 flex-shrink-0 text-lg font-bold"
                            ><img
                              alt="Chevron"
                              loading="lazy"
                              width="24"
                              height="24"
                              decoding="async"
                              data-nimg="1"
                              class="group-data-[state=open]:rotate-180"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg" /></span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="overflow-hidden transition-all duration-300 ease-in-out block"
                      ref="content0"
                      :style="{maxHeight: tab===0?content0.scrollHeight+'px':'0px'}"
                    >
                      <div
                        class="flex flex-col justify-between pb-2 pt-1 tracking-[-0.14px] desktop-sm:flex-row text-sm not-italic font-normal leading-5 text-grey-8"
                      >
                        SIP investments are open to investors from all
                        categories. You can also choose investments across
                        different asset classes. But, the SIP investment should
                        be based on your financial goal, investment horizon and
                        risk appetite.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-4 border-b border-b-light-4 pb-4 last:border-0">
                  <div>
                    <div class="cursor-pointer" @click="changeTab(1)">
                      <div
                        class="group flex w-full items-start justify-between px-0 py-2 text-left leading-10 md:items-center"
                         :data-state="tab===1?'open':'closed'"
                      >
                        <div
                          class="inter-display-font flex w-full items-center justify-between"
                        >
                          <h3
                            class="w-full tracking-[-0.24px] text-base not-italic font-semibold leading-6 text-dark-6"
                          >
                            How much can I invest in SIP?
                          </h3>
                          
                          <span class="ml-2 flex-shrink-0 text-lg font-bold"
                            ><img
                              alt="Chevron"
                              loading="lazy"
                              width="24"
                              height="24"
                              decoding="async"
                              data-nimg="1"
                              class="group-data-[state=open]:rotate-180"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg" /></span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="overflow-hidden transition-all duration-300 ease-in-out block"
                      ref="content1"
                      :style="{maxHeight: tab===1?content0.scrollHeight+'px':'0px'}"
                    >
                      <div
                        class="flex flex-col justify-between pb-2 pt-1 tracking-[-0.14px] desktop-sm:flex-row text-sm not-italic font-normal leading-5 text-grey-8"
                      >
                        You can begin your SIP investments for as low as ₹100
                        per month and there is no maximum limit.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-4 border-b border-b-light-4 pb-4 last:border-0">
                  <div>
                    <div class="cursor-pointer" @click="changeTab(2)">
                      <div
                        class="group flex w-full items-start justify-between px-0 py-2 text-left leading-10 md:items-center"
                        :data-state="tab===2?'open':'closed'"
                      >
                        <div
                          class="inter-display-font flex w-full items-center justify-between"
                        >
                          <h3
                            class="w-full tracking-[-0.24px] text-base not-italic font-semibold leading-6 text-dark-6"
                          >
                            How to use the SIP Calculator?
                          </h3>
                          
                          <span class="ml-2 flex-shrink-0 text-lg font-bold"
                            ><img
                              alt="Chevron"
                              loading="lazy"
                              width="24"
                              height="24"
                              decoding="async"
                              data-nimg="1"
                              class="group-data-[state=open]:rotate-180"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg" /></span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="overflow-hidden transition-all duration-300 ease-in-out block"
                      ref="content2"
                      :style="{maxHeight: tab===2?content0.scrollHeight+'px':'0px'}"
                    >
                      <div
                        class="flex flex-col justify-between pb-2 pt-1 tracking-[-0.14px] desktop-sm:flex-row text-sm not-italic font-normal leading-5 text-grey-8"
                      >
                        To use the SIP Calculator, enter your monthly SIP
                        amount, duration and expected rate of return. The
                        calculator will show the total maturity value along with
                        the returns on investment.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-4 border-b border-b-light-4 pb-4 last:border-0">
                  <div>
                    <div class="cursor-pointer" @click="changeTab(3)">
                      <div
                        class="group flex w-full items-start justify-between px-0 py-2 text-left leading-10 md:items-center"
                         :data-state="tab===3?'open':'closed'"
                      >
                        <div
                          class="inter-display-font flex w-full items-center justify-between"
                        >
                          <h3
                            class="w-full tracking-[-0.24px] text-base not-italic font-semibold leading-6 text-dark-6"
                          >
                            How to extend SIP duration?
                          </h3>
                          
                          <span class="ml-2 flex-shrink-0 text-lg font-bold"
                            ><img
                              alt="Chevron"
                              loading="lazy"
                              width="24"
                              height="24"
                              decoding="async"
                              data-nimg="1"
                              class="group-data-[state=open]:rotate-180"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg" /></span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="overflow-hidden transition-all duration-300 ease-in-out block"
                      ref="content3"
                      :style="{maxHeight: tab===3?content0.scrollHeight+'px':'0px'}"
                    >
                      <div
                        class="flex flex-col justify-between pb-2 pt-1 tracking-[-0.14px] desktop-sm:flex-row text-sm not-italic font-normal leading-5 text-grey-8"
                      >
                        The SIP duration can be extended by placing a request
                        with the fund house. You can do it both online and
                        offline.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-4 border-b border-b-light-4 pb-4 last:border-0">
                  <div>
                    <div class="cursor-pointer" @click="changeTab(4)">
                      <div
                        class="group flex w-full items-start justify-between px-0 py-2 text-left leading-10 md:items-center"
                         :data-state="tab===4?'open':'closed'"
                      >
                        <div
                          class="inter-display-font flex w-full items-center justify-between"
                        >
                          <h3
                            class="w-full tracking-[-0.24px] text-base not-italic font-semibold leading-6 text-dark-6"
                          >
                            How does the SIP Calculator work?
                          </h3>
                          
                          <span class="ml-2 flex-shrink-0 text-lg font-bold"
                            ><img
                              alt="Chevron"
                              loading="lazy"
                              width="24"
                              height="24"
                              decoding="async"
                              data-nimg="1"
                              class="group-data-[state=open]:rotate-180"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg" /></span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="overflow-hidden transition-all duration-300 ease-in-out block"
                      ref="content4"
                      :style="{maxHeight: tab===4?content0.scrollHeight+'px':'0px'}"
                    >
                      <div
                        class="flex flex-col justify-between pb-2 pt-1 tracking-[-0.14px] desktop-sm:flex-row text-sm not-italic font-normal leading-5 text-grey-8"
                      >
                        The SIP Calculator estimates the maturity value of your
                        investments based on monthly amount, duration and the
                        rate of return.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-4 border-b border-b-light-4 pb-4 last:border-0">
                  <div>
                    <div class="cursor-pointer" @click="changeTab(5)">
                      <div
                        class="group flex w-full items-start justify-between px-0 py-2 text-left leading-10 md:items-center"
                         :data-state="tab===5?'open':'closed'"
                      >
                        <div
                          class="inter-display-font flex w-full items-center justify-between"
                        >
                          <h3
                            class="w-full tracking-[-0.24px] text-base not-italic font-semibold leading-6 text-dark-6"
                          >
                            Can SIP be withdrawn anytime?
                          </h3>
                          
                          <span class="ml-2 flex-shrink-0 text-lg font-bold"
                            ><img
                              alt="Chevron"
                              loading="lazy"
                              width="24"
                              height="24"
                              decoding="async"
                              data-nimg="1"
                              class="group-data-[state=open]:rotate-180"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg" /></span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="overflow-hidden transition-all duration-300 ease-in-out block"
                      ref="content5"
                      :style="{maxHeight: tab===5?content0.scrollHeight+'px':'0px'}"
                    >
                      <div
                        class="flex flex-col justify-between pb-2 pt-1 tracking-[-0.14px] desktop-sm:flex-row text-sm not-italic font-normal leading-5 text-grey-8"
                      >
                        In most cases, SIPs can be withdrawn at your
                        convenience, but certain schemes come with a lock-in
                        period. Withdrawals during the lock-in period may
                        attract penalty or additional charges.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-4 border-b border-b-light-4 pb-4 last:border-0">
                  <div>
                    <div class="cursor-pointer" @click="changeTab(6)">
                      <div
                        class="group flex w-full items-start justify-between px-0 py-2 text-left leading-10 md:items-center"
                        :data-state="tab===6?'open':'closed'"
                      >
                        <div
                          class="inter-display-font flex w-full items-center justify-between"
                        >
                          <h3
                            class="w-full tracking-[-0.24px] text-base not-italic font-semibold leading-6 text-dark-6"
                          >
                            Can the SIP amount be increased?
                          </h3>
                          <span class="ml-2 flex-shrink-0 text-lg font-bold"
                            ><img
                              alt="Chevron"
                              loading="lazy"
                              width="24"
                              height="24"
                              decoding="async"
                              data-nimg="1"
                              class="group-data-[state=open]:rotate-180"
                              style="color: transparent"
                              src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg" /></span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="overflow-hidden transition-all duration-300 ease-in-out block"
                      ref="content6"
                      :style="{maxHeight: tab===6?content0.scrollHeight+'px':'0px'}"
                    >
                      <div
                        class="flex flex-col justify-between pb-2 pt-1 tracking-[-0.14px] desktop-sm:flex-row text-sm not-italic font-normal leading-5 text-grey-8"
                      >
                        Yes, you can increase the SIP amount anytime, using the
                        step-up option.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class=" top-28 mt-16 xs:hidden max-w-[320px] shrink-0 self-start md:block"
        >
          <div class="flex flex-col gap-3">
            <div
              class="mb-5 flex flex-col rounded-2xl border border-grey-7 p-4"
            >
              <div class="flex flex-col items-center justify-center">
                <div
                  class="text-center text-[13px] font-semibold not-italic leading-5 text-grey-8"
                >
                  Invest Right, Invest Now
                </div>
                <div
                  class="pt-2 text-center text-lg font-semibold not-italic leading-[26px] text-dark-6"
                >
                  Trusted by 1 cr+ Indians for their wealth-building needs
                </div>
                <div class="my-6 rounded-lg border border-gray-300 px-4">
                  <div class="m-auto mt-2 flex items-center">
                    <div class="mr-3 min-w-[54px] text-primary-base2">
                      <p
                        class="inline-block align-top text-lg font-normal leading-[26px]"
                      >
                        ₹
                      </p>
                      <p
                        class="text--primary-accent relative top-[-3px] inline-block align-top text-[32px] font-semibold leading-[42px]"
                      >
                        0
                      </p>
                    </div>
                    <div class="text-[13px] font-normal not-italic text-grey-8">
                      Account maintenance charges (AMC)
                    </div>
                  </div>
                  <hr class="my-2 h-px w-full bg-gray-300" />
                  <div class="m-auto flex items-center">
                    <div class="mr-3 min-w-[54px] text-primary-base2">
                      <p
                        class="inline-block align-top text-lg font-normal leading-[26px]"
                      >
                        ₹
                      </p>
                      <p
                        class="text-brand-light-purple relative top-[-3px] inline-block align-top text-[32px] font-semibold leading-[42px]"
                      >
                        0
                      </p>
                    </div>
                    <div class="text-[13px] font-normal not-italic text-grey-8">
                      Commission on Mutual Funds and IPOs
                    </div>
                  </div>
                  <hr class="my-2 h-px w-full bg-gray-300" />
                  <div class="m-auto mb-2 flex items-center">
                    <div class="mr-3 min-w-[54px] text-primary-base2">
                      <p
                        class="inline-block align-top text-lg font-normal leading-[26px]"
                      >
                        ₹
                      </p>
                      <p
                        class="text-brand-light-purple relative top-[-3px] inline-block align-top text-[32px] font-semibold leading-[42px]"
                      >
                        20
                      </p>
                    </div>
                    <div class="text-[13px] font-normal not-italic text-grey-8">
                      Brokerage of up to ₹20/order on Equity and F&amp;O
                    </div>
                  </div>
                </div>
              </div>
              <div class="relative flex items-center text-base leading-6">
                <div
                  class="absolute left-4 top-4 flex items-center text-sm font-semibold leading-5 text-black"
                >
                  <img
                    alt="indian-flag"
                    loading="lazy"
                    width="16"
                    height="12"
                    decoding="async"
                    data-nimg="1"
                    class="mr-1"
                    style="color: transparent"
                    src="@/styles/img/calculator/next-calculator-assets/indian-flag.svg"
                  /><span class="font-semibold">+91</span>
                </div>
                <input
                  autocomplete="off"
                  autocorrect="off"
                  type="tel"
                  class="h-[52px] w-full gap-3 rounded-lg border !border-grey-9 !bg-light-1 !px-4 !py-2 !pl-[68px] outline-none"
                  placeholder="Mobile number"
                  name="phoneInput"
                  value=""
                />
              </div>
              <span class="text-xs text-red-600"></span
              ><button
                class="cursor-pointer px-4 text-sm font-semibold disabled:cursor-not-allowed hover-none:bg-primary-dark bg-primary-base text-white active:bg-primary-dark2 disabled:bg-primary-base/50 dark:bg-purpleDark-4 rounded-lg mt-3 w-full py-3"
              >
                Start Investing
              </button>
              <p
                class="pt-2 text-[10px] font-normal not-italic leading-4 text-dark-2"
              >
                By signing up, you agree to receive transaction updates from
                Upstox.
              </p>
            </div>
            <div
              class="hidden flex flex-col text-base font-semibold not-italic leading-6"
            >
              <p class="border-b border-solid border-b-grey-7 pb-6 text-[18px]">
                Related SIP Calculators
              </p>
              <a
                target="_self"
                class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
                href="/calculator/sbi-sip-calculator/"
                ><p>SBI SIP calculator</p></a
              ><a
                target="_self"
                class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
                href="/calculator/hdfc-sip-calculator/"
                ><p>HDFC SIP calculator</p></a
              ><a
                target="_self"
                class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
                href="/calculator/pnb-sip-calculator/"
                ><p>PNB SIP calculator</p></a
              ><a
                target="_self"
                class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
                href="/calculator/icici-sip-calculator/"
                ><p>ICICI SIP calculator</p></a
              ><a
                target="_self"
                class="cursor-pointer border-b border-solid border-b-grey-7 py-6 text-base font-medium text-grey-8"
                href="/calculator/axis-sip-calculator/"
                ><p>Axis SIP calculator</p></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<style scoped lang="scss">
p {
  /* margin: 0 !important; */
}

.upstox-radio-group {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 1rem;
    padding: .25rem .5rem .25rem 0;
    .radio-wrapper {
        display: flex;
        align-items: center
    }

    .radio-input {
        display: none
    }

    .radio-label {
        position: relative;
        display: flex;
        cursor: pointer;
        align-items: center;
        padding-left: 1.5rem;
        font-size: .875rem;
        line-height: 1.25rem;
        font-weight: 400;
        line-height: normal;
        --tw-text-opacity: 1;
        color: rgb(68 68 68/var(--tw-text-opacity));
        outline: none
    }

    .radio-label:before {
        position: absolute;
        left: 0;
        height: 1rem;
        width: 1rem;
        border-radius: 50%;
        border-width: 1px;
        border-style: solid;
        --tw-border-opacity: 1;
        border-color: rgb(0 0 0/var(--tw-border-opacity))
    }

    .radio-label:after,.radio-label:before {
        --tw-content: "";
        content: var(--tw-content)
    }

    .radio-input:checked+.radio-label:after {
        position: absolute;
        left: 3px;
        top: 50%;
        height: .625rem;
        width: .625rem;
        --tw-translate-y: -50%;
        transform: translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
        border-radius: 50%;
        --tw-bg-opacity: 1;
        background-color: rgb(0 0 0/var(--tw-bg-opacity));
        --tw-content: "";
        content: var(--tw-content)
    }
}

</style>
